import { Box } from '@mui/material';
import { Link } from '@portals/core/src/components/Link/Link';
import { theme } from '@portals/core/src/themes/immobilien/main';
import { CheckboxInput } from '@portals/forms/src/components/CheckboxInput/CheckboxInput';
import { getFixedT } from 'i18next';
import React from 'react';

import { getStyles } from '../../EstateContact.styles';

interface LegalCheckboxProps {
  showPrivacyPolicy: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  showConsumerInformation: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  consumerInformation: string;
}

const t = getFixedT(null, 'core-immobilien');

export const LegalCheckbox = ({
  showPrivacyPolicy,
  showConsumerInformation,
  consumerInformation,
}: LegalCheckboxProps): React.ReactElement => {
  const styles = getStyles(theme);

  const renderLegalCheckBoxLabel = () => {
    const privacyPolicyLink = (
      <Link onClick={showPrivacyPolicy} sx={styles.link}>
        {t('detailPage.privacyPolicy')}
      </Link>
    );

    const consumerInformationLink = (
      <Link onClick={showConsumerInformation} sx={styles.link} style={{ margin: 0 }}>
        {t('detailPage.consumerInformation')}
      </Link>
    );

    const privacyPolicyLabel = (
      <>
        {t('detailPage.privacyPolicyRead1')}
        {privacyPolicyLink}
        {t('detailPage.privacyPolicyRead2')}
      </>
    );

    const privacyPolicyAndConsumerInformationLabel = (
      <>
        {t('detailPage.privacyPolicyConsumerInformationRead1')}
        {privacyPolicyLink}
        {t('detailPage.privacyPolicyConsumerInformationRead2')}
        {consumerInformationLink}
        {t('detailPage.privacyPolicyConsumerInformationRead3')}
      </>
    );

    return (
      <Box sx={styles.infoContainer}>
        {consumerInformation ? privacyPolicyAndConsumerInformationLabel : privacyPolicyLabel}
      </Box>
    );
  };

  return (
    <Box className="legal-checkbox" sx={styles.legaCheckBox}>
      <CheckboxInput name="accept" color="secondary" label={renderLegalCheckBoxLabel()} sx={{ m: 0 }} />
    </Box>
  );
};

LegalCheckbox.displayName = 'LegalCheckbox';
